module.exports = __webpack_public_path__ + "static/img/culture5.2e2d4bda.jpg";